import { Link } from "react-router-dom";
import { useState } from "react";

export default function CTASection() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.currentTarget as HTMLFormElement;
    const honeypot = (form.querySelector('[name="website_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) { setStatus("success"); setMessage("订阅成功！感谢您的关注。"); return; }
    try {
      const formData = new FormData(form);
      const response = await fetch("http://uhomekj.com/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = {}; }
      if (response.ok && parsed?.code === "OK") {
        setStatus("success");
        setMessage("订阅成功！感谢您的关注，精彩漫画更新不再错过。");
        setEmail("");
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText;
        setStatus("error");
        setMessage(serverMsg || "订阅失败，请稍后重试。");
      }
    } catch {
      setStatus("error");
      setMessage("网络错误，请检查网络后重试。");
    }
  };

  return (
    <section className="relative py-20 md:py-28 px-4 md:px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20soft%20atmospheric%20background%20with%20gentle%20cream%20and%20peach%20gradient%20tones%2C%20abstract%20flowing%20organic%20shapes%2C%20dreamy%20ethereal%20mood%2C%20minimalist%20artistic%20illustration%20style%2C%20delicate%20floating%20light%20particles%2C%20cinematic%20soft%20focus%2C%20warm%20golden%20hour%20ambient%20light%2C%20no%20text%20no%20people&width=1920&height=800&seq=cta-bg-home-02&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-black text-white mb-4">
          立即加入韩漫大全
        </h2>
        <p className="text-white/70 text-sm md:text-base mb-8 max-w-md mx-auto leading-relaxed">
          订阅我们的更新通知，第一时间获取最新韩漫上架信息，精彩内容不再错过
        </p>

        <form
         
          id="newsletter-form"
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
        >
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="输入您的邮箱地址"
            required
            className="flex-1 px-5 py-3 rounded-full bg-white/10 border border-white/20 text-white placeholder-white/40 text-sm focus:outline-none focus:border-primary-500 transition-colors"
          />
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="form-anti-spam"
          />
          <button
            type="submit"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-all cursor-pointer"
          >
            免费订阅
          </button>
        </form>

        {status !== "idle" && (
          <p className={`mt-4 text-sm ${status === "success" ? "text-green-300" : "text-red-300"}`}>
            {message}
          </p>
        )}
      </div>
    </section>
  );
}